export const baseSearchUrl = '/search/lang/NXQL/execute';
export const addPermissionUrl = '/automation/Document.AddPermission';
export const removePermissionUrl = '/automation/Document.RemovePermission';
export const logoutNuxeo = 'logout?noredirect=true';
export const meNuxeo = 'api/v1/me/';
export const queryInit = 'query';
